import { render, staticRenderFns } from "./WhyVideoModal.vue?vue&type=template&id=fda97016&"
import script from "./WhyVideoModal.vue?vue&type=script&lang=js&"
export * from "./WhyVideoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports